var map = {
	"./auto-register.js": "JZf1",
	"./auto-require.js": "IWEE",
	"./clipboard.js": "uOfe",
	"./dialog.js": "oTpX",
	"./pluginManager.js": "Y6E7",
	"./settingManager.js": "3MAv",
	"./tips.js": "y/py",
	"./windowControl.js": "mZy9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OQEr";


//////////////////
// WEBPACK FOOTER
// ./src/plugins nonrecursive .+\.js$
// module id = OQEr
// module chunks = 11